module.exports = __webpack_public_path__ + "static/img/yxz.bd78c81d.png";